import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const AddGlobaldataToken = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.AddGlobaldataToken,
        method: RequestType.POST,
        data,
    });

const UpdateGlobaldataToken = (id: number): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateGlobaldataToken + '/' + id,
        method: RequestType.PUT,
        data: {},
    });

const DeleteGlobaldataToken = (id: any) =>
    request({
        url: ApiURL.Command.DeleteGlobaldataToken + '/' + id,
        method: RequestType.DELETE,
    });

const DeleteSupportedCountry = (params: any) =>
    request({
        url: ApiURL.Command.DeleteSupportedCountry + '?id=' + params?.id,
        method: RequestType.DELETE,
    });

const CreateSupportedCountry = (param: any) =>
    request({
        url: ApiURL.Command.CreateSupportedCountry,
        method: RequestType.POST,
        data: param,
    });

const UpdateSupportedCountry = (param: any) =>
    request({
        url: ApiURL.Command.UpdateSupportedCountry,
        method: RequestType.PUT,
        data: param,
    });

const SortSupportedCountries = (param: any) =>
    request({
        url: ApiURL.Command.SortSupportedCountries,
        method: RequestType.PUT,
        data: param,
    });

const DeleteSupportedLanguage = (params: any) =>
    request({
        url: ApiURL.Command.DeleteSupportedLanguage + '?id=' + params?.id,
        method: RequestType.DELETE,
    });

const CreateSupportedLanguage = (param: any) =>
    request({
        url: ApiURL.Command.CreateSupportedLanguage,
        method: RequestType.POST,
        data: param,
    });

const UpdateSupportedLanguage = (param: any) =>
    request({
        url: ApiURL.Command.UpdateSupportedLanguage,
        method: RequestType.PUT,
        data: param,
    });

const SortSupportedLanguages = (param: any) =>
    request({
        url: ApiURL.Command.SortSupportedLanguages,
        method: RequestType.PUT,
        data: param,
    });

const GlobaldataDeleteRedisKey = (databaseNumber: number, key: string): Promise<any> =>
    request({
        url: `${ApiURL.Command.GlobaldataDeleteRedisKey}/${databaseNumber}/${encodeURIComponent(key)}`,
        method: RequestType.DELETE,
    });

const GlobaldataBulkDeleteRedisKeys = (databaseNumber: number, keys: string[]): Promise<any> =>
    request({
        url: ApiURL.Command.GlobaldataBulkDeleteRedisKeys,
        method: RequestType.POST,
        data: {
            databaseNumber,
            keys,
        },
    });

const GlobaldataDeleteCache = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GlobaldataDeleteCache,
        method: RequestType.POST,
        data,
    });

const UpdateSupportedCurrency = (param: any) =>
    request({
        url: ApiURL.Command.UpdateSupportedCurrency,
        method: RequestType.PATCH,
        data: param,
    });

const GlobaldataCommand = {
    DeleteGlobaldataToken,
    UpdateGlobaldataToken,
    AddGlobaldataToken,
    DeleteSupportedLanguage,
    SortSupportedCountries,
    SortSupportedLanguages,
    UpdateSupportedLanguage,
    UpdateSupportedCountry,
    CreateSupportedLanguage,
    CreateSupportedCountry,
    DeleteSupportedCountry,
    GlobaldataDeleteRedisKey,
    GlobaldataBulkDeleteRedisKeys,
    GlobaldataDeleteCache,
    UpdateSupportedCurrency,
};

export default GlobaldataCommand;
